<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-form ref="tabelBantuanForm" id="tabelBantuanForm" v-model="valid" lazy-validation>
                <v-toolbar flat>
                    <v-toolbar-title>Tabel Bantuan</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                    <v-btn color="grey" dark class="mb-2 mr-2" @click="backToBantuan" small>
                        <v-icon small>mdi-arrow-left</v-icon>
                        Back
                    </v-btn>
                </v-toolbar>
                <div class="mt-3">
                    <v-row class="mx-5">
                        <v-col cols="2">Outlet</v-col>
                        <v-col cols="2">
                            <v-skeleton-loader type="text" v-if="isLoadingOutlet" />
                            <span v-else>{{ outlet.code }} - {{ outlet.name }}</span>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5">
                        <v-col cols="2">Date</v-col>
                        <v-col cols="2">
                            <v-skeleton-loader type="text" v-if="isLoadingOutlet" />
                            <v-menu v-else v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form" :rules="reqRule"></v-text-field>
                                </template>
                                <v-date-picker v-model="date" @change="setDate"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="2">Variant Bottle / Volume</v-col>
                        <v-col cols="2">
                            <v-skeleton-loader type="text" v-if="isLoadingOutlet" />
                            <span v-else>
                                <v-select outlined dense hide-details="auto" class="compact-form" :items="filteredBotols" item-value="code" item-text="description" return-object v-model="bottle" @change="onChangeBottle" />
                            </span>
                        </v-col>
                    </v-row>
                    <section class="view">
                        <v-simple-table class="spreadsheet-tabel mb-0">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="header-cell" colspan="5">
                                            Call Center : {{ callCenter }}
                                        </th>
                                        <th class="header-cell text-center">Sisa Closing</th>
                                        <th class="header-cell text-center text-no-wrap">Buffer <br/>(Min Stock Closing)</th>
                                        <th class="header-cell text-center">Selisih</th>
                                        <th class="header-cell" colspan="4"></th>
                                    </tr>
                                    <tr>
                                        <th class="header-cell" colspan="5">
                                            Koordinator : {{ koordinator }}
                                        </th>
                                        <td class="spreadsheet-cell text-center" style="width: 50px;"><v-text-field type="number" v-model="sisaClosing" solo hide-details class="spreadsheet-input" @wheel="$event.target.blur()" /></td>
                                        <td class="spreadsheet-cell text-center" style="width: 50px;"><v-text-field type="number" v-model="minStockClosing" solo hide-details class="spreadsheet-input" @wheel="$event.target.blur()" /></td>
                                        <th class="spreadsheet-cell text-center" style="width: 50px;"></th>
                                        <th class="header-cell" style="width: 50px;"></th>
                                        <th class="header-cell" style="width: 50px;"></th>
                                        <th class="header-cell" style="width: 50px;"></th>
                                        <th class="header-cell" style="width: 50px;"></th>
                                    </tr>
                                    <tr>
                                        <th class="header-cell" colspan="5"></th>
                                        <td class="spreadsheet-cell text-center" style="width: 50px;">{{ persenSisaClosing }}%</td>
                                        <td class="spreadsheet-cell text-center" style="width: 50px;">{{ persenMinStockClosing }}%</td>
                                        <th class="spreadsheet-cell text-center" style="width: 50px;"></th>
                                        <th class="header-cell" style="width: 50px;"></th>
                                        <th class="header-cell" style="width: 50px;"></th>
                                        <th class="header-cell" style="width: 50px;"></th>
                                        <th class="header-cell" style="width: 50px;"></th>
                                    </tr>
                                </thead>
                            </template>
                        </v-simple-table>
                        <v-simple-table class="spreadsheet-tabel" fixed-header height="440">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="header-cell" colspan="5"></th>
                                        <th class="header-cell text-center" style="width: 50px;">Sisa Closing</th>
                                        <th class="header-cell text-center text-no-wrap" style="width: 50px;">Buffer <br/>(Min Stock Closing)</th>
                                        <th class="header-cell text-center" style="width: 50px;">Selisih</th>
                                        <th class="header-cell" colspan="4"></th>
                                    </tr>
                                    <tr>
                                        <th class="header-cell" width="10">NO</th>
                                        <th class="header-cell">KODE</th>
                                        <th class="header-cell">PRODUK</th>
                                        <th class="header-cell text-center" style="width: 50px;">PPIC (PO)</th>
                                        <th class="header-cell text-center" style="width: 50px;">Sisa Sekarang<br/>(Refresh Get Stock Iseller)</th>
                                        <th class="header-cell text-center">Sisa Closing</th>
                                        <th class="header-cell text-center">Buffer</th>
                                        <th class="header-cell text-center">Aktual Kirim <br/> (Termasuk Buffer)</th>
                                        <th class="header-cell text-center" style="width: 50px;">Adjustment</th>
                                        <th class="header-cell text-center" style="width: 50px;">After Adjustment</th>
                                        <th class="header-cell text-center" style="width: 50px;">Volume Tester</th>
                                        <th class="header-cell text-center" style="width: 50px;">Quantity Tester</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, idx) in items" :key="idx">
                                        <td class="header-cell">{{ idx + 1 }}</td>
                                        <td class="header-cell text-no-wrap">{{ row.product_code }}</td>
                                        <td class="header-cell text-no-wrap">{{ row.product_name }} ({{ row.product_size }}ML)</td>
                                        <td class="spreadsheet-cell text-center">{{ calculateQtyPO(row) }}</td>
                                        <td class="spreadsheet-cell">
                                            <v-text-field type="number" v-model="row.quantity_sisa_jam3" solo hide-details class="spreadsheet-input" @wheel="$event.target.blur()" />
                                        </td>
                                        <td class="spreadsheet-cell text-center">{{ calculateSisaClosing(row) }}</td>
                                        <td class="spreadsheet-cell text-center">{{ calculateBuffer(row) }}</td>
                                        <td class="spreadsheet-cell text-center">{{ calculateAktualKirimText(row) }}</td>
                                        <td class="spreadsheet-cell text-center">
                                            <v-text-field type="number" :value="getQtyAdjustPO(row)" @input="updateQtyAdjustPO(row, $event)" solo hide-details class="spreadsheet-input" @wheel="$event.target.blur()" />
                                        </td>
                                        <td class="spreadsheet-cell text-center">{{ calculateAfterAdjustment(row) }}</td>
                                        <td class="spreadsheet-cell text-center">
                                            <v-select solo hide-details="auto" clearable class="new-compact-form spreadsheet-input"  :items="botols" item-value="code" item-text="description" v-model="row.volume_tester" 
                                            @change="onVolumeChange(row, $event)" @click:clear="onVolumeClear(row, $event)"/>
                                        </td>
                                        <td class="spreadsheet-cell text-center">
                                            <v-text-field type="number" v-model="row.quantity_tester" solo hide-details class="spreadsheet-input" @wheel="$event.target.blur()" />
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th class="header-cell text-right" colspan="3">TOTAL</th>
                                        <th class="spreadsheet-cell text-center">{{ totalPPIC }}</th>
                                        <th class="spreadsheet-cell text-center">{{ totalSisaJam3 }}</th>
                                        <th class="spreadsheet-cell text-center">{{ totalSisaClosing }}</th>
                                        <th class="spreadsheet-cell text-center">{{ totalBuffer }}</th>
                                        <th class="spreadsheet-cell text-center">{{ totalAktualKirim }}</th>
                                        <th class="spreadsheet-cell text-center">{{ totalAdjustment }}</th>
                                        <th class="spreadsheet-cell text-center">{{ totalAfterAdjustment }}</th>
                                        <th class="spreadsheet-cell text-center">&nbsp;</th>
                                        <th class="spreadsheet-cell text-center">{{ totalTester }}</th>
                                    </tr>
                                </tfoot>
                            </template>
                        </v-simple-table>
                    </section>
                </div>
                <v-card-actions class="pr-4 mx-5">
                    <v-spacer />
                    <v-btn depressed color="green" dark @click="getCurrentStock" :loading="saveProgressStock">
                        Get Stock iSeller 
                    </v-btn>
                    <v-btn depressed color="primary" @click="saveBantuan" :loading="saveProgress">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>

        <v-dialog v-model="showDialogConfirm" max-width="400px">
        <v-card>
            <v-card-title class="headline">Success</v-card-title>
            <v-card-text>
                Your data has been saved successfully.
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showDialogConfirm = false">OK</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <v-snackbar top v-model="saveError" color="red accent-2" :timeout="5000">
            Data gagal tersimpan! {{ errorMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="saveError = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>

    </div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            sisaClosing: 0,
            minStockClosing: 0,
            items: [],
            items_po: [],
            outlet: {},
            valid: true,
            isLoading: false,
            isLoadingOutlet: false,
            saveProgress: false,
            saveProgressStock: false,
            saved: false,
            saveError: false,
            dateMenu: false,
            date: null,
            bottle: {},
            selectedBottle: '',
            botols: [],
            filteredBotols: [],
            reqRule: [v => !!v || 'Harus diisi!'],
            dayNumber: 0,
            showDialogConfirm: false,
            errorMessage: '',
        }
    },

    computed: {
        totalPPIC() {
            return this.items_po.reduce((total, item) => total + Number(item.quantity_ordered), 0);
        },
        totalSisaJam3() {
            return this.items.reduce((total, item) => total + Number(item.quantity_sisa_jam3), 0);
        },
        totalSisaClosing() {
            return this.items.reduce((total, item) => total + this.calculateSisaClosing(item), 0);
        },
        totalBuffer() {
            return this.items.reduce((total, item) => total + this.calculateBuffer(item), 0);
        },
        totalAktualKirim() {
            return this.items.reduce((total, item) => total + this.calculateAktualKirim(item), 0);
        },
        totalAdjustment() {
            return this.items.reduce((total, item) => total + Number(this.getQtyAdjustPO(item)), 0);
        },
        totalAfterAdjustment() {
            return this.items.reduce((total, item) => total + Number(item.quantity_after_adjustment), 0);
        },
        totalTester() {
            return this.items.reduce((total, item) => total + Number(item.quantity_tester), 0);
        },
        persenSisaClosing() {
            if (this.totalSisaJam3 > 0) {
                return Math.round(this.sisaClosing / this.totalSisaJam3 * 100);
            } else {
                return 0;
            }
        },
        persenMinStockClosing() {
            if (this.totalPPIC > 0) {
                return Math.round(this.minStockClosing / this.totalPPIC * 100); 
            } else {
                return 0;
            }
        },
        callCenter() {
            if (this.outlet.call_center) {
                return this.outlet.call_center.name;
            } else {
                return '';
            }
        },
        koordinator() {
            switch (this.dayNumber) {
                case 0:
                    return this.outlet.coordinator_mon_name;
                case 1:
                    return this.outlet.coordinator_sun_name;
                case 2:
                    return this.outlet.coordinator_tue_name;
                case 3:
                    return this.outlet.coordinator_wed_name;
                case 4:
                    return this.outlet.coordinator_thu_name;
                case 5:
                    return this.outlet.coordinator_fri_name;
                case 6:
                    return this.outlet.coordinator_sat_name;
                default:
                    return '';
            }
        },
        statusEdit() {
            return true;
            // return this.items.some(item => item.status_pembagian_koordinator === 1) ? 1 : 0;
        },
        variants() {
            return this.$store.state.variant.objs
        },

    },

    async created() {
        this.getBotols();

        this.date = moment().format('YYYY-MM-DD');

        this.fetchOutlet();

        this.$store.dispatch('variant/getObjs');
    },

    methods: {
        getBotols() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.botols = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });

            this.bottle = this.botols.slice(0, 1)[0];
        },
        filterBotols() {
            if (this.outlet.botols.length === 0) {
                this.filteredBotols = this.botols
            } else {
                this.filteredBotols = this.botols.filter(item => this.outlet.botols.includes(item.code))
            }

            this.bottle = this.filteredBotols.slice(0, 1)[0];
        },
        onChangeBottle() {
            this.fetchBantuan();
        },
        setDate() {
            this.fetchBantuan();
        },
        async fetchOutlet() {
            this.isLoadingOutlet = true;
            const outletCode = this.$route.params.code;

            try {
                const data = (await this.$store.dispatch('outlet/getObj', outletCode));
                this.outlet = data;
                this.selectedBotol = this.outlet.botols;
                this.filterBotols();

                this.fetchBantuan();
            } catch (error) {
                console.error('Error fetching outlet:', error);
            } finally {
                this.isLoadingOutlet = false;
            }
        },
        async fetchBantuan() {
            this.isLoading = true;
            const outletCode = this.$route.params.code;

            try {
                const data = (await this.$store.dispatch('bantuan/getData', {
                    outlet_code: outletCode,
                    size: this.bottle.code,
                    date: this.date,
                }));

                this.sisaClosing = data.sisa_closing;
                this.minStockClosing = data.min_stock_closing;
                this.items = data.items;
                this.items_po = data.items_po;
                this.dayNumber = data.day_number;
            } catch (error) {
                console.error('Error fetching detail planning:', error);
            } finally {
                this.isLoading = false;
            } 
        },
        calculateSisaClosing(item) {
            return Math.round(Number(item.quantity_sisa_jam3) * (this.persenSisaClosing / 100), 0);
        },
        calculateBuffer(item) {
            return Math.round(this.calculateQtyPO(item) * (this.persenMinStockClosing / 100), 0); 
        },
        calculateAktualKirim(item) {
            let result = this.calculateQtyPO(item) + this.calculateSisaClosing(item) + this.calculateBuffer(item);
            if (result > 0) {
                result = this.calculateQtyPO(item) - this.calculateSisaClosing(item) + this.calculateBuffer(item);
            }

            this.calculateQtyDeliveredPO(item, result);

            if (result < 0) {
                result = 0;
                return result;
            } else {
                if (result == 0) {
                    return 0;
                } else {
                    return result;
                }
            }
        },
        calculateAfterAdjustment(item) {

            const qtyAdj = Number(this.getQtyAdjustPO(item));
            const actualKirim = Number(this.calculateAktualKirim(item));

            const result = actualKirim + qtyAdj;          

            this.$set(item, 'quantity_after_adjustment', result);
            return result;

        },
        calculateAktualKirimText(item) {
            let result = this.calculateQtyPO(item) + this.calculateSisaClosing(item) + this.calculateBuffer(item);
            if (result > 0) {
                result = this.calculateQtyPO(item) - this.calculateSisaClosing(item) + this.calculateBuffer(item);
            }

            if (result < 0) {
                result = 0;
                return result;
            } else {
                if (result == 0) {
                    return '';
                } else {
                    return result;
                }
            }

        },
        calculateQtyPO(item) {
            let result = 0;

            const product = this.items_po.find((i) => i.product_code === item.product_code);
            if (product) {
                result = parseInt(product.quantity_ordered);
            }

            return result;
        },
        getQtyAdjustPO(item) {
            let result = 0;

            const product = this.items_po.find((i) => i.product_code === item.product_code);
            if (product) {
                result = parseInt(product.quantity_adjustment);
            }

            return result;
        },
        updateQtyAdjustPO(item, value) {
            const product = this.items_po.find(i => i.product_code === item.product_code);
            if (product) {
                const result = parseInt(value) || 0;
                this.$set(item, 'quantity_adjustment', result);
                product.quantity_adjustment = result;
            }
        },
        onVolumeChange(item) {
            const match = this.variants.find(variant =>
                variant.name == item.product_name &&
                variant.size == item.volume_tester
            );
            if (item.volume_tester === null || item.volume_tester === '') {
                item.product_code_tester = null;
                return;
            }
            if (!match) {
                this.$store.commit('setSnackbar', {
                    saveError: true,
                    errorMessage: 'Produk '+ item.product_name + ' untuk volume '+item.volume_tester+'ml tidak ditemukan. Silakan pilih produk dan volume yang sesuai.'
                });
                item.volume_tester = '';
                item.product_code_tester = '';
                item.quantity_tester = 0;
            }
            else {
                item.product_code_tester = match.code;
            }
        },
        onVolumeClear(item) {
            item.product_code_tester = '';
            item.volume_tester = '';
            item.quantity_tester = 0;
        },
        calculateQtyDeliveredPO(item, qty) {
            const product = this.items_po.find((i) => i.product_code === item.product_code);
            if (product) {
                if (qty < 0) {
                    qty = 0;
                }
                product.quantity_delivered = qty;
            }
        },
        async saveBantuan() {
            await this.$refs.tabelBantuanForm.validate();

            if (!this.valid) return;

            this.saveProgress = true;

            const outletCode = this.$route.params.code;

            try {
                const result = await this.$store.dispatch('bantuan/save', {
                    outlet_code: outletCode,
                    delivery_date: this.date,
                    size: this.bottle.code,
                    min_stock_closing: this.minStockClosing,
                    items: this.items,
                    items_po: this.items_po,
                });

                if (result.status == 200 || result.status == 201) {
                    // this.$router.go(-1);
                    // this.$router.push(`/tabel-bantuan`);
                    this.saved = true;
                    this.showDialogConfirm = true;
                } else {
                    this.errorMessage = result.data?.message || 'Terjadi kesalahan saat menyimpan data.';
                    this.saveError = true;
                }

                this.saveProgress = false;
            } catch (error) {
                console.error('Error save bantuan', error);
                this.errorMessage = error.response?.data?.message || error.message || 'Terjadi kesalahan saat menyimpan data.';
                this.saveError = true;
            } finally {
                this.saveProgress = false;
            }
        },
        async getCurrentStock() {
            try {
                this.saveProgressStock = true;

                await this.$store.dispatch('getObjs', {
                    apidomain: 'iseller/getcurrentstock',
                    parameter: `/${this.outlet.iseller_outlet_code}?date=${this.date}`
                });

                this.fetchOutlet();
            } catch (error) {
                console.error('Error getting current stock:', error);
                // Optionally notify the user with a toast or message
            } finally {
                this.saveProgressStock = false;
            }
        },
        backToBantuan() {
            this.$router.push(`/tabel-bantuan`);
        }
    }
}
</script>

<style scoped>
.no-padding-table td {
    padding: 0 !important;
    margin: 0 !important;
}
td .v-text-field {
    width: 100%;
}

.spreadsheet-table {
  border-collapse: collapse;
  width: 100%;
}

.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 100px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 0px !important;
}

.spreadsheet-cell:focus-within {
  background-color: #e6f7ff;
  outline: none;
}

.spreadsheet-input {
  padding: 0 !important;
  margin: 0;
  border: none;
  box-shadow: none;
  /* background-color: transparent !important; */
  background-color: yellow !important;
  font-size: inherit;
  width: 100%;
}

.spreadsheet-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.compact-input {
  font-size: 0.8rem;
  padding: 0 !important;
  margin: 0 !important;
}

.compact-input .v-input__control {
  min-height: 36px !important; /* Adjust to make it more compact */
}

.compact-input .v-label {
  font-size: 0.7rem !important;
}

.compact-input .v-input__slot {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.view {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

.table-container {
  display: flex;
  margin-top: 20px;
  flex-grow: 1;
  overflow: hidden;
}

.flex-table {
  display: flex;
  flex-grow: 1;
  width: 100%;
}

.flex-table > div {
  width: 100%;
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>